import styled from "styled-components";
import { COLORS } from "Styles/Constants";
import IntroLayers from "../../Assets/Images/LandingPage/intro_box_layer.svg";

export const WhoWeAreContainer = styled.div`
  .whoweare_section {
    padding: 100px 0;

    .who_we_are_content {
      max-width: 625px;

      .intro_learnmore {
        padding-top: 15px;
        padding-bottom: 20px;
      }
    }

    .intro-image-wrapper {
      position: relative;
      display: inline-block;
    }

    .intro-image {
      width: 100%;
      border-radius: 0 50px;
    }

    .intro-video{
      width:100%;
      border-radius:0 50px;
    }

    .ai-center {
      display:flex;
      align-items:center;
    }

    .video-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 145px;
      height: auto;
      cursor: pointer;
      filter: drop-shadow(0 0 10px #197f9f);
      animation: glow 2s infinite alternate;
    }

    @keyframes glow {
      from {
        filter: drop-shadow(0 0 10px #197f9f);
      }
      to {
        filter: drop-shadow(0 0 25px rgba(238, 45, 47, 1));
      }
    }

    .intro_boxes-wrapper {
      padding: 50px 0;
      padding-bottom: 0;
    }

    .intro-box {
      position: relative;
      width: 100%;
      min-height: 280px;
      border-radius: 0 50px;
      cursor: pointer;
      z-index: 1;

      &:after {
        position: absolute;
        content: "";
        background: url(${IntroLayers}) no-repeat;
        width: 100%;
        height: 100%;
        bottom: 0;
        right: 0;
        background-position: bottom right;
        background-size: 228px;
        z-index: 0;
      }

      .intro-inner-wrapper {
        position: relative;
        border-radius: 0 50px;
        overflow: hidden;
        height: 100%;
      }

      .intro-inner {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 0.6s ease;
        transform-style: preserve-3d;
      }

      .front,
      .back {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 50px 35px;
        backface-visibility: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        text-align: left;
        border-radius: 0 50px;
      }

      .front {
        transform: rotateY(0deg);
        z-index: 2;
      }

      .back {
        transform: rotateY(180deg);
        z-index: 1;
      }

      .intro-inner.flipped {
        transform: rotateY(180deg);
      }
    }
  }

.intro-image-wrapper {
    width: 100%;
}
.intro-image-wrapper iframe {
    width: 100%;
    border-radius: 0 50px;
    min-height: 528px;
}


  /* Responsive */
  @media (max-width: 1199px) {
    .whoweare_section .video-icon {
      width: 84px !important;
    }
    .whoweare_section .intro_boxes-wrapper .intro-box-col {
        margin-bottom: 20px;
    }

    .who_we_are_content h4 {
      font-size: 29px;
    }

    .whoweare_section {
      padding: 70px 0;
      padding-bottom: 30px;
    }
    .intro-image-wrapper iframe {
        min-height: 437px;
    }

  }

  @media (max-width: 991px) {
    .whoweare_section .mygrid-row {
      flex-direction: column-reverse;
    }

    .whoweare_section .who_we_are_content {
      margin-top: 70px;
    }

    .whoweare_section .who_we_are_content h2 br {
      display: none;
    }
    .whoweare_section .intro_boxes-wrapper {
      padding: 30px 0;
      padding-bottom: 0;
    }
    .whoweare_section .who_we_are_content {
        max-width: 100%;
    }
    .who_we_are_content h4 {
        font-size: 21px;
    }    
    .intro-image-wrapper iframe {
        min-height: 760px;
    }

  }

  @media (max-width: 767px) {
    .whoweare_section .who_we_are_content {
      max-width: 100%;
      margin-top: 50px;
      margin-bottom: 25px;
    }

    .whoweare_section {
      padding: 50px 0;
      padding-bottom: 10px;
    }
    .whoweare_section .who_we_are_content .intro_learnmore {
        padding-top: 15px;
        padding-bottom: 0;
    }
    .intro-image-wrapper iframe {
        min-height: 368px;
    }
  }
`;
